import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useContext, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import cx from 'classnames';
import EditorOverlay from './EditorOverlay';
import Input from '../components/shared/Input';
import Button from '../components/shared/Button';
import useToggle from '../hooks/useToggle';
import EditorContext from '../store/Editor.context';
import { setRedactStep, setReviewStep, setProcessing } from '../store';
import { normalizePayload } from '../utils/normalizePayload';
import FreePdf from '../services/FreePdf';
import toast from '../components/shared/Toasts';

var EditorDropwdownReview = function EditorDropwdownReview() {
  var _errors$review;

  var _useToggle = useToggle(false),
      isOn = _useToggle[0],
      toggleIsOn = _useToggle[1];

  var _useToggle2 = useToggle(false),
      isOther = _useToggle2[0],
      toggleIsOther = _useToggle2[1];

  var _useContext = useContext(EditorContext),
      dispatch = _useContext.dispatch,
      state = _useContext.state;

  var _useForm = useForm(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.errors;

  var handleClose = useCallback(function () {
    toggleIsOn(false);
    toggleIsOther(false);
  }, []);
  var onSubmit = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return FreePdf.feedback(values);

            case 3:
              toast.success({
                description: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, "Thanks for taking the time to help us improve our service"), /*#__PURE__*/React.createElement("div", {
                  className: "mt-1 font-bold text-xs"
                }, "\u2022 Jeff, CEO"))
              });
              handleClose();
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              toast.error({
                description: _context.t0
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  var handleCancel = useCallback(function () {
    if (!isOther) {
      handleClose();
    } else {
      toggleIsOther(false);
    }
  }, [isOther]);

  var handleReEdit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var payload, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              handleClose();
              dispatch(setProcessing('Preparing your document for review...'));
              payload = normalizePayload(state.changes.present, 'rereview');
              _context2.next = 6;
              return FreePdf.reviewPDF(payload);

            case 6:
              data = _context2.sent;

              if (data.Notice) {
                toast.notice({
                  description: data.Notice
                });
              }

              dispatch(setReviewStep(data.getUrl, true));
              dispatch(setProcessing(false));
              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              toast.error({
                description: _context2.t0
              });

            case 15:
              _context2.prev = 15;
              dispatch(setProcessing(false));
              return _context2.finish(15);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 12, 15, 18]]);
    }));

    return function handleReEdit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleEdit = function handleEdit() {
    handleClose();
    dispatch(setRedactStep);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "relative inline-block text-left z-10"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "rounded-md shadow-sm"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: toggleIsOn,
    className: cx([{
      'pointer-events-none': isOn
    }])
  }, "Doesn\u2019t look right"))), /*#__PURE__*/React.createElement(EditorOverlay, {
    open: isOn,
    onClose: handleClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "popup bg-white shadow sm:rounded-lg absolute transform left-1/2 mt-3 -translate-x-1/2 max-w-xl"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-5 sm:p-6"
  }, !isOther ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg leading-6 font-medium text-gray-900",
    id: "renew-headline"
  }, "Doesn\u2019t look right"), /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleReEdit,
    className: "bg-gray-300 hover:bg-gray-400 text-gray-800 py-1 px-4 rounded inline-flex items-center"
  }, /*#__PURE__*/React.createElement("span", null, "Redaction doesn\u2019t remove objects properly"))), /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleEdit,
    className: "bg-gray-300 hover:bg-gray-400 text-gray-800 py-1 px-4 rounded inline-flex items-center"
  }, /*#__PURE__*/React.createElement("span", null, "I want to change redaction"))), /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: toggleIsOther,
    className: "bg-gray-300 hover:bg-gray-400 text-gray-800 py-1 px-4 rounded inline-flex items-center"
  }, /*#__PURE__*/React.createElement("span", null, "Other")))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg leading-6 font-medium text-gray-900",
    id: "renew-headline"
  }, "What could we improve?"), /*#__PURE__*/React.createElement(Input, {
    ref: register(),
    name: "name",
    label: "Full name",
    placeholder: "Name"
  }), /*#__PURE__*/React.createElement(Input, {
    ref: register(),
    name: "email",
    type: "email",
    label: "Email",
    placeholder: "Email"
  }), /*#__PURE__*/React.createElement("textarea", {
    ref: register({
      required: 'Field is required'
    }),
    name: "description",
    autoFocus: true,
    id: "about",
    rows: "4",
    className: "mt-4 form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 resize-none"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mt-2"
  }, /*#__PURE__*/React.createElement("input", {
    ref: register(),
    id: "permission",
    name: "permission",
    type: "checkbox",
    className: "form-checkbox h-4 w-4 text-primaty transition duration-150 ease-in-out"
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "permission",
    className: "ml-2 block text-sm leading-5 text-gray-900"
  }, "Collect information about this request to improve the redactor")), /*#__PURE__*/React.createElement("p", {
    className: "text-negative text-sm h-5"
  }, (_errors$review = errors.review) === null || _errors$review === void 0 ? void 0 : _errors$review.message)), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 flex justify-between"
  }, /*#__PURE__*/React.createElement("span", {
    className: "inline-flex rounded-md shadow-sm"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: handleCancel
  }, "Cancel")), isOther && /*#__PURE__*/React.createElement("span", {
    className: "inline-flex rounded-md shadow-sm"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cx([{
      'border-grey-100 pointer-events-none text-grey-100': errors.length
    }]),
    type: "submit"
  }, "Submit"))))))));
};

export default EditorDropwdownReview;